import React from "react";

import * as typography from "@client/shared/typography";

import * as components from "@client/site/components";
import * as forms from "@client/site/forms";

export const Template = () => (
    <components.Layout title="Demo setup">
        <form noValidate method="POST" action="" encType="multipart/form-data">
            <forms.CSRFToken />
            <typography.Header>Demo setup</typography.Header>
            <typography.P>
                This can take up to 3 minutes. If you get a timeout error, just re-run
                it within 5 minutes of the first run.
            </typography.P>
            <typography.Button submit name="submit">
                Setup
            </typography.Button>
        </form>
    </components.Layout>
);
